enum MpTrackingButtons {
    // Playback
    PLAY = 'Play',
    PAUSE = 'Pause',
    SCRUB = 'MoveProgressBar',
    ADJUST_VOLUME = 'AdjustVolume',
    ADJUST_SPEED = 'AdjustSpeed',

    // Navigation
    NAVIGATE_TO_NOA = 'NavigateToNoa',
    TRENDING_ARTICLES_PAGE = 'TrendingArticlesPage',
    SEARCH_PAGE = 'SearchPage',
    QUEUE_PAGE = 'QueuePage',

    // Miscellaneous
    SHARE = 'Share',
    CLICK_HERE_CTA = 'ClickHereCta',
    ARTICLE_TEXT = 'ArticleText',
}

export default MpTrackingButtons
